<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="row">
        <div class="col-md-12 mb-20">
          <label class="d-block text-black fw-semibold mb-10">
            Image du produit
          </label>
          <div class="d-flex align-items-center">
            <img
              :src="
                product.pic
                  ? product.pic
                  : require('@/assets/images/NoImage.png')
              "
              class="rounded-circle me-15"
              style="width: 90px; height: 90px; object-fit: cover"
            />

            <div>
              <input
                ref="updateImgInput"
                type="file"
                accept="image/*"
                class="d-none"
                @change="logoSelected"
              />
              <button
                type="button"
                class="btn btn-primary me-2"
                @click="() => updateImgInput?.click()"
              >
                Choisir la photo
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="cancelImage"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10"
              >Nom du produit</label
            >
            <input
              type="text"
              class="form-control shadow-none rounded-0 text-black"
              placeholder="e.g. Sensung Smart Watch"
              v-model="product.name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Description Produit
            </label>
            <div class="mb-0">
              <textarea
                v-model="product.desc"
                placeholder="Write your product description"
                class="form-control shadow-none rounded-0 text-black"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <button
            type="button"
            @click="editProduct()"
            class="btn btn-primary btn-sm"
            :disabled="loadingEdit"
          >
            <span
              v-if="loadingEdit"
              class="spinner-border spinner-border-sm me-1"
            ></span>
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="row">
        <div class="col-md-10">
          <div class="form-group">
            <label style="font-size: 0.957rem">Choisir une agence * :</label>
            <v-select
              :options="agencyList"
              v-model="agency"
              label="name"
              class="custom-select-height"
            >
            </v-select>
          </div>
        </div>

        <div class="col-md-2 d-flex align-items-end">
          <button
            v-if="auth.can('STOCK')"
            class="btn btn-primary"
            @click="receivedAgency"
            style="margin-top: 1.2rem"
          >
            <i class="flaticon-check-mark-1"></i> Reçu
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
    <div class="card-header"><h5>Réception par code-barres</h5><p class="mb-0">Scannez la référence du produit pour confirmer sa réception.</p></div>
    <div class="card-body">
      <form v-if="auth.can('STOCK')" class="row g-2 align-items-end" @submit.prevent="scanInventoryBarcode">
        <div class="col-md-9">
          <label for="inventoryBarcode" class="form-label">Code-barres / Référence produit</label>
          <input id="inventoryBarcode" ref="barcodeInput" v-model="scannedBarcode" type="text" class="form-control"
            placeholder="Scannez ou saisissez la référence" autocomplete="off" :disabled="barcodeLoading || product.received != 1" />
        </div>
        <div class="col-md-3">
          <button type="submit" class="btn btn-success w-100" :disabled="barcodeLoading || !scannedBarcode.trim() || product.received != 1">
            <span v-if="barcodeLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
            <i v-else class="ph ph-scan me-1"></i>Réceptionner le produit
          </button>
        </div>
        <div v-if="product.received != 1" class="col-12 text-muted small">Sélectionnez d’abord une agence et confirmez la réception du produit.</div>
      </form>
    </div>
  </div>

  <vue-good-table :columns="columns" :rows="product.variantsList">
    <template #table-row="props">
      <!-- Column: Name -->
      <span v-if="props.column.field === 'inventory_ref'" class="d-flex flex-column align-items-start">
        <form @submit.prevent="updateInventoryRef(props.row)" class="w-100">
          <div class="input-group">
            <input type="text" class="form-control" v-model="props.row.inventory_ref" />
            <button type="button" class="btn btn-outline-secondary btn-sm" title="Copier la reference" :disabled="!props.row.inventory_ref" @click="copyInventoryRef(props.row)"><i class="ph ph-copy"></i></button>
            <button type="submit" class="btn btn-primary btn-sm" title="Enregistrer la reference"><i class="flaticon-diskette"></i></button>
          </div>
        </form>
        <img v-if="props.row.barcode_svg" class="mt-2" :src="'data:image/svg+xml;base64,' + props.row.barcode_svg" :alt="'Code-barres ' + props.row.inventory_ref" style="max-width: 220px; height: 48px" />
      </span>

      <form v-else-if="props.column.field === 'location'" @submit.prevent="updateInventoryLocation(props.row)">
        <div class="input-group" style="min-width: 150px">
          <input type="text" class="form-control" maxlength="100" placeholder="Ex : A-02" v-model="props.row.location" />
          <button type="submit" class="btn btn-primary btn-sm" title="Enregistrer l'emplacement"><i class="flaticon-diskette"></i></button>
        </div>
      </form>

      <span v-else-if="props.column.field === 'stores'" class="text-nowrap">
        <template
          v-if="
            props.row.inventories_stores &&
            props.row.inventories_stores.length != 0
          "
        >
          <span
            class="text-nowrap"
            v-for="(str, indx) in props.row.inventories_stores"
            :key="indx"
          >
            {{ str.magasin.name }}
            <small> ({{ str.magasin.market }})</small></span
          >
        </template>
      </span>

      <!-- Column: Status -->
      <span v-else-if="props.column.field === 'qty_not_received'">
        <div class="d-flex align-items-center">
          <input
            type="number"
            min="-500000"
            max="500000"
            class="form-control"
            v-model="props.row.qty_not_received"
          />
          <button
            v-if="auth.can('STOCK')"
            style="margin-left: 1%"
            class="btn btn-info"
            @click="editQnty(props.row)"
          >
            <i class="ph ph-floppy-disk"></i>
          </button>
        </div>
      </span>
      <!-- Column: Action -->
      <span v-else-if="props.column.field === 'action'">
        <button type="button" class="btn btn-outline-primary btn-sm text-nowrap"
          :disabled="!props.row.inventory_ref" @click.stop="openBarcodePdf(props.row)">
          <i class="ph ph-file-pdf me-1"></i>PDF du code-barres
        </button>
      </span>

      <!-- Column: Common -->
      <span v-else>
        {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
  </vue-good-table>

  <div class="row mt-40">
    <div class="col-md-6 mb-2">
      <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
        <div class="card-header">
          <h5>Historique</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <input
            v-model="searchHist"
            placeholder="Chercher"
            type="text"
            class="form-control d-inline-block mb-2"
          />
          <vue-good-table :columns="columnsHist" :rows="histories">
            <!-- <template v-slot:emptystate></template> -->
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <template v-if="props.column.field === 'history_type'">
                <b>{{ props.row.text }}</b>
              </template>
               <template v-else-if="props.column.field === 'action_by_name'">
                <b>{{ props.row.action_by_name }}</b>
              </template>
              <template v-else-if="props.column.field === 'created_at'">
                <span>{{ getDate(props.row.created_at) }}</span
                ><br />
              </template>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
          <TablePager
            :pagination="pagerHist"
            v-model:per-page="perPageHist"
            @paginate="fetchHistories"
          />
        </div>
      </div>
    </div>
    <div class="col-md-6 mb-2">
      <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
        <div class="card-header">
          <h5>Colis avec ce produit</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <input
            v-model="searchColis"
            placeholder="Chercher"
            type="text"
            class="form-control d-inline-block mb-2"
          />
          <vue-good-table :columns="columnsColis" :rows="colis">
            <!-- <div slot="emptystate"></div> -->
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <template v-if="props.column.field === 'parcel_code'">
                <span>{{ props.row.parcel_code }}</span
                ><br />
              </template>
              <template v-else-if="props.column.field === 'created_at'">
                <span>{{ getDate(props.row.created_at) }}</span>
              </template>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
          <TablePager
            :pagination="pagerColis"
            v-model:per-page="perPageColis"
            @paginate="fetchColis"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useServerTable } from "@/composables/useServerTable";

export default defineComponent({
  name: "EditProduct",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup: (props) => {
    const auth = useAuthStore();
    const user = auth.user;

    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const loading = ref(false);
    const loadingEdit = ref(false);
    const barcodeInput = ref<HTMLInputElement | null>(null);
    const scannedBarcode = ref("");
    const barcodeLoading = ref(false);

    const agencyList = ref([]);
    const agency = ref(null);

    const { showToast } = useAppToast();

    const variants = ref(false);
    const items = ref([{ id: Date.now(), ref: "", name: "", qnty: 1 }]);
    const customer = ref<{ id?: number; name?: string }>({});
    const prod_name = ref("");
    const ref_prod = ref("");
    const note_prod = ref("");
    const qnty = ref(1);
    const image = ref<File | null>(null);

    const product = ref({
      // pic: null as File | null,
      id: 0,
      customer: 0,
      customer_name: "",
      name: "",
      desc: "",
      variant: 0,
      stock_zone: null,
      stock_agency: null,
      stock_agency_name: null,
      received: 0,
      received_time: null,
      received_by: null,
      received_by_name: null,
      added_time: null,
      created_at: "",
      updated_at: "",
      variantsList: [],
      pic: null,
    });
    // History and parcels of the product: one page at a time from the API, searched server-side
    const {
      rows: histories,
      pager: pagerHist,
      searchTerm: searchHist,
      perPage: perPageHist,
      load: fetchHistories,
    } = useServerTable({ url: () => `/api/auth/show_history_prod/${props.id}` });
    const {
      rows: colis,
      pager: pagerColis,
      searchTerm: searchColis,
      perPage: perPageColis,
      load: fetchColis,
    } = useServerTable({ url: "/api/auth/ProductParcels", params: () => ({ prod_id: props.id }) });

    const columns = [
      {
        label: "#Réf",
        field: "inventory_ref",
      },
      {
        label: "Nom de la variante",
        field: "var_name",
      },
      {
        label: "Emplacement",
        field: "location",
        sortable: false,
      },
      {
        label: "Reçu",
        field: "qty",
      },
      {
        label: "Pas encore reçu",
        field: "qty_not_received",
      },
      {
        label: "Agence",
        field: "agency_name",
      },
      {
        label: "Action",
        field: "action",
      },
    ];
    const columnsHist = [
      {
        label: "Historique",
        field: "history_type",
      },{
        label: "Effectué par",
        field: "action_by_name",
      },
      {
        label: "Date",
        field: "created_at",
      },
    ];
    const columnsColis = [
      {
        label: "Code d'envoi",
        field: "parcel_code",
      },
      {
        label: "Date",
        field: "created_at",
      },
    ];

    // 🟢 Fetch clients
    onMounted(async () => {
      try {
        const res = await api.get(`/api/auth/AgencyInvent`);
        agencyList.value = res.data;
      } catch (error) {
        console.error("Error fetching agencies:", error);
        agencyList.value = [];
      }
      showProduct();

      // historiques
      fetchHistories(1);
      // colis
      fetchColis(1);
    });

    async function showProduct() {
      // 🟢 Fetch existing product details
      try {
        const res = await api.get(`/api/auth/show_product/${props.id}`);
        const p = res.data;

        Object.assign(product.value, p);
      } catch (error) {
        console.error("Error fetching product:", error);
        showToast("Impossible de charger le produit", "error");
      }
    }

    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        image.value = file;
        imagepreview.value = URL.createObjectURL(file);
        product.value.pic = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      image.value = null;
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const editProduct = async () => {
      const data = new FormData();

      // Append text data
      data.append("id", product.value.id.toString());
      data.append("name", product.value.name);
      data.append("desc", product.value.desc);

      // Append the file if one was selected
      if (image.value) {
        data.append("image", image.value);
      }

      try {
          loadingEdit.value = true;
        // IMPORTANT: Use POST even for updates when sending files.
        // Some backends have trouble parsing PUT/PATCH with FormData.
        // You can use data.append('_method', 'PUT') to spoof it in Laravel.
        data.append("_method", "POST");

        const res = await api.post(
          `/api/auth/editProduct/${product.value.id}`,
          data,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        showToast("Produit mis à jour avec succès", "success");
      } catch (err) {
          loadingEdit.value = false;

        showToast("Erreur lors de la modification", "error");
      }finally {
          loadingEdit.value = false;

      }
    };

    const repeateAgain = () => {
      items.value.push({
        id: Date.now() + Math.random(),
        ref: "",
        name: "",
        qnty: 1,
      });
    };

    const removeItem = (index: number) => {
      items.value.splice(index, 1);
    };

    // 🟢 Update Product
    async function updateProduct() {
      if (Object.keys(customer.value).length === 0) {
        showToast("Merci de choisir un client", "error");
        return;
      }

      const data = new FormData();
      data.append(
        "cstmr_id",
        customer.value.id !== undefined ? String(customer.value.id) : ""
      );
      data.append("cstmr_name", customer.value.name ?? "");
      data.append("prod_name", prod_name.value ?? "");
      data.append("prod_desc", note_prod.value ?? "");
      data.append("ref_prod", ref_prod.value ?? "");
      data.append("list", JSON.stringify(items.value));
      data.append("variants", variants.value ? "1" : "0");
      data.append("qnty", String(qnty.value ?? 1));

      if (image.value) {
        data.append("image", image.value); // only send new image
      }

      loading.value = true;
      try {
        const res = await api.post(
          `/api/auth/updateProduct/${props.id}`,
          data,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        loading.value = false;

        if (res.data.message === "success") {
          showToast("Produit mis à jour avec succès", "success");
        } else if (res.data.message === "exist") {
          showToast(
            "Cette référence " + res.data.ref + " est déjà existante",
            "error"
          );
        }
      } catch (error) {
        loading.value = false;
        console.error(error);
        showToast("Erreur lors de la mise à jour", "error");
      }
    }

    async function receivedAgency() {
      if (Object.keys(agency.value).length == 0) {
        showToast("Merci de choisir une agence", "error");
      } else {
        let data = new FormData();
        data.append("agency_id", agency.value.id);
        data.append("agency_name", agency.value.name);
        data.append("prod_id", props.id);
        data.append("user_id", user?.id);
        data.append("user_name", user?.name);
        try {
          const res = await api.post(`/api/auth/Received`, data);
          if (res.data.message == "success") {
            showProduct();
            showToast("ajouté avec succès", "success");
          }
        } catch (error) {
          showToast("Erreur lors de l'ajout", "error");
        }
      }
    }
    async function scanInventoryBarcode() {
      const barcode = scannedBarcode.value.trim();
      if (!barcode) return;
      const row = product.value.variantsList.find((variant: any) =>
        String(variant.inventory_ref ?? "").trim().toLowerCase() === barcode.toLowerCase()
      );
      if (!row) {
        showToast("Unknown barcode for this product", "error");
        scannedBarcode.value = "";
        barcodeInput.value?.focus();
        return;
      }
      await receiveInventory(row, barcode);
    }

    async function copyInventoryRef(row: any) {
      const text = String(row.inventory_ref ?? "").trim();
      if (!text) return;
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        const el = document.createElement("textarea");
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      showToast("Référence copiée", "success");
    }

    async function openBarcodePdf(row: any) {
      const popup = window.open("about:blank", "_blank");
      try {
        const response = await api.get(
          "/api/auth/inventory/" + row.id + "/barcode-pdf",
          { responseType: "blob" }
        );
        const pdfUrl = URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        if (popup) {
          popup.location.href = pdfUrl;
        } else {
          window.location.href = pdfUrl;
        }
      } catch (error) {
        if (popup) popup.close();
        showToast("Impossible d'ouvrir le PDF du code-barres", "error");
      }
    }

    async function receiveInventory(row: any, barcode: string) {
      const data = new FormData();
      data.append("var_id", String(row.id));
      data.append("prod_id", String(props.id));
      data.append("barcode", barcode);
      barcodeLoading.value = true;
      try {
        const res = await api.post("/api/auth/ReceiveInventory", data);
        if (res.data.message === "success") {
          scannedBarcode.value = "";
          await showProduct();
          fetchHistories(1);
          showToast("Product received", "success");
        } else if (res.data.message === "barcode mismatch") {
          showToast("Barcode does not match the expected product reference", "error");
        } else {
          showToast(res.data.message ?? "Could not receive product", "error");
        }
      } catch (error) {
        showToast("Could not receive product", "error");
      } finally {
        barcodeLoading.value = false;
        barcodeInput.value?.focus();
      }
    }

    async function editQnty(row) {
      let data = new FormData();
      data.append("var_id", row.id);
      data.append("qnty", row.qty_not_received);
      // data.append('prod_id', row.code_color);
      const res = await api.post(`/api/auth/editVariant`, data);
      if (res.data.message == "success") {
        showProduct();
        fetchHistories(1);
        showToast("Quantité modifiée avec succès", "success");
      }
    }
    function getDate(value) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function updateInventoryRef(row) {
      try {
        // Example: send data to backend using Axios
        const res = await api.post("/api/auth/update-inventory-ref", {
          inventory_id: row.id, // assuming each row has an ID
          inventory_ref: row.inventory_ref,
        });

        if (res.data.success) {
          showToast(
            "Référence d'inventaire mise à jour avec succès",
            "success"
          );
        } else {
          showToast(
            "Échec de la mise à jour de la référence d'inventaire",
            "error"
          );
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Failed to update inventory reference.");
      }
    }

    async function updateInventoryLocation(row) {
      try {
        const res = await api.post("/api/auth/update-inventory-location", {
          inventory_id: row.id,
          location: row.location || "",
        });
        showToast(
          res.data.success ? "Emplacement mis à jour avec succès" : "Échec de la mise à jour de l'emplacement",
          res.data.success ? "success" : "error"
        );
      } catch (error) {
        console.error(error);
        showToast("Échec de la mise à jour de l'emplacement", "error");
      }
    }

    return {
      updateInventoryLocation,
      updateImgInput,
      imagepreview,
      logoSelected,
      cancelImage,
      variants,

      repeateAgain,
      removeItem,
      items,
      updateProduct,

      loading,
      customer,
      ref_prod,
      prod_name,
      note_prod,
      qnty,
      image,
      product,
      auth,
      receivedAgency,
      receiveInventory,
      openBarcodePdf,
      copyInventoryRef,
      editQnty,
      agency,
      agencyList,
      getDate,

      columnsColis,
      columnsHist,
      columns,
      histories,
      colis,
      pagerHist,
      pagerColis,
      searchHist,
      searchColis,
      perPageHist,
      perPageColis,
      fetchHistories,
      fetchColis,
      updateInventoryRef,
      editProduct,
      loadingEdit,
      barcodeInput,
      scannedBarcode,
      barcodeLoading,
      scanInventoryBarcode
    };
  },
});
</script>
